module.exports = __webpack_public_path__ + "static/media/home.609cd29a.png";